/* eslint-disable import/prefer-default-export */
export const TRANSACTION_AMT_ALIASES = {
  buyer: "Budget",
  seller: "Estimated Home Value",
  tenant: "Monthly Budget",
  landlord: "Estimated Monthly Rent",
};
